module.exports = __webpack_public_path__ + "static/media/baladeiro.c25ebc07.jpg";